import Banner from '../../container/CommitteeBanner'
import PaoAnn from '../../assets/speakers/Pao-Ann.jpg'
import Maheswari from '../../assets/speakers/Maheswari.jpg'
import Thanikaiselvan from '../../assets/speakers/thanikaiselvan.jpg' // placeholder if exact file not available
import Sabarimalai from '../../assets/speakers/Sabarimalai-manikandan.jpg'
import Nagarajan from '../../assets/speakers/Nagarajan.jpg'
import Udhayakumar from '../../assets/speakers/Ydhayakumar.jpg'
import Sundaram from '../../assets/speakers/Sundaram.jpg'
import Sakthivel from '../../assets/speakers/Sakthivel.jpg'
import Radha from '../../assets/speakers/Radha.jpg'
import Ramalatha from '../../assets/speakers/Ramalatha-marimuthu.jpg'
export default function KeySpeakers() {
    const speakers = [
        {
            name: 'Dr. Pao-Ann Hsiung',
            lines: [
                'Professor and Director of the Research Center on AI and Sustainability,',
                'National Chung Cheng University (CCU), Taiwan.'
            ],
            topic: 'Smart Systems Design / AI for Sustainable Development through Engineering and Computing Technologies',
            img: PaoAnn
        },
        {
            name: 'Dr. Maheswari S S',
            lines: [
                'Software Development Specialist,',
                'Bosch Global Software Technologies,',
                'Coimbatore, TN, INDIA.'
            ],
            topic: 'From Automation to Autonomy: The Impact of Agentic AI on Everyday Life',
            img: Maheswari
        },
        {
            name: 'Dr. V. Thanikaiselvan',
            lines: [
                'Professor - School of Electronics Engineering,',
                'Researcher - AI & ML, Dept. of Communication Engg.,',
                'Vellore Institute of Technology, Vellore, TN, INDIA.'
            ],
            topic: 'Secured Data Transmission Methods for Next Generation Communication Systems',
            img: Thanikaiselvan
        },
        {
            name: 'Dr. M. Sabarimalai Manikandan',
            lines: [
                'Associate Professor,',
                'Department of Electrical Engineering,',
                'Indian Institute of Technology Palakkad, Kerala, INDIA.'
            ],
            topic: 'Deep Learning Networks for Event Detection and Classification: Concepts, Key Challenges and Future Directions',
            img: Sabarimalai
        },
        {
            name: 'Dr. V. Nagarajan',
            lines: [
                'Professor,',
                'Department of Electronics Engineering,',
                'Pondicherry University, Pondicherry, INDIA.'
            ],
            topic: 'Integrating Machine Learning into Real-Time / Embedded Wireless Systems',
            img: Nagarajan
        },
        {
            name: 'Dr. K. Udhayakumar',
            lines: [
                'Professor,',
                'Department of Electrical and Electronics Engineering',
                'Anna University, TN, INDIA.'
            ],
            topic: 'Emerging Trends in Power Converter Topologies: Challenges and Opportunities',
            img: Udhayakumar
        },
        {
            name: 'Dr. M. Sundaram',
            lines: [
                'Associate Professor,',
                'Department of Electrical and Electronics Engineering,',
                'PSG College of Technology, Coimbatore, TN, INDIA.'
            ],
            topic: 'Advances in Power Electronics and Drives for Electric Mobility: Key Challenges and Future Opportunities',
            img: Sundaram
        }
    ];

    return(
        <main>
            <Banner title={'Keynote Speakers'} context={'We are honored to present our distinguished Keynote Speakers of AECTSD 2025, invited to deliver a featured address at a conference. Their presentations set the tone for the event, aligning with its central theme. The industry leaders and renowned academics, will share their insights on cutting-edge technologies on topics pertaining to the scope of the conference.'} />

            {/* Speaker Rows */}
            <section className="px-4 sm:px-6 lg:px-10 py-8 space-y-8">
                {speakers.map((spk, idx) => (
                    <div key={idx} className="flex flex-col md:flex-row items-start md:items-start gap-5 sm:gap-8 max-w-6xl mx-auto w-full">
                        {/* Photo */}
                        <div className="shrink-0 self-center md:self-stretch flex">
                            <img
                                src={spk.img}
                                alt={spk.name}
                                className="w-28 sm:w-32 md:w-36 lg:w-40 xl:w-44 h-full rounded object-cover border"
                            />
                        </div>

                        {/* Details */}
                        <div className="flex-1 w-full">
                            <div className="rounded-2xl border p-4 sm:p-5 lg:p-6 w-full">
                                <h3 className="text-lg sm:text-xl lg:text-2xl font-semibold leading-snug">{spk.name}</h3>
                                <div className="mt-2 sm:mt-3 text-gray-700 leading-relaxed text-sm sm:text-base">
                                    {spk.lines.map((line, i) => (
                                        <p key={i}>{line}</p>
                                    ))}
                                </div>
                            </div>

                            {/* Topic */}
                            <div className="mt-3 sm:mt-4 w-full">
                                <p className="font-semibold text-sm sm:text-base">
                                    Topic:
                                    <span className="font-normal ml-2 block sm:inline mt-1 sm:mt-0">{spk.topic}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                ))}
            </section>

            {/* Technical Co-Sponsor Invited Guests */}
            <section className="px-4 sm:px-6 lg:px-10 py-12">
                <h2 className="text-center text-2xl sm:text-3xl font-bold tracking-wide mb-10">
                    TECHNICAL CO-SPONSOR INVITED GUESTS
                </h2>

                <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 place-items-center">
                    {[
                        {
                            name: 'Dr. P. Sakthivel',
                            role: 'Chairman',
                            img: Sakthivel
                        },
                        {
                            name: 'Dr. S. Radha',
                            role: 'Secretary\nChairman',
                            img: Radha
                        },
                        {
                            name: 'Dr. Ramalatha Marimuthu',
                            role: 'Vice-Chairman – Industry',
                            img: Ramalatha
                        }
                    ].map((g, i) => (
                        <div key={i} className="flex flex-col items-center text-center">
                            <img
                                src={g.img}
                                alt={g.name}
                                className="w-40 h-40 sm:w-44 sm:h-44 object-cover rounded shadow"
                            />
                            <p className="mt-4 text-primary-blue font-bold underline">{g.name}</p>
                            <p className="text-gray-700 mt-1 whitespace-pre-line">{g.role}</p>
                        </div>
                    ))}
                </div>
            </section>
        </main>
    )
}